import type { Capability } from '../api/types';

export type CapabilityKey = Exclude<keyof Capability, 'role'>;

/** Display grouping for the per-user permissions editor (mirrors the backend keys). */
export const PERMISSION_GROUPS: Array<{
  label: string;
  keys: Array<{ key: CapabilityKey; label: string; hint?: string }>;
}> = [
  {
    label: 'Pages',
    keys: [
      { key: 'canViewClients', label: 'Clients' },
      { key: 'canViewProjects', label: 'Projects' },
    ],
  },
  {
    label: 'Operations',
    keys: [
      { key: 'canOperate', label: 'Operate records', hint: 'Mutate clients/projects' },
      { key: 'canEditTracks', label: 'Edit project tracks', hint: 'Plan + progress reporting' },
      { key: 'canManageTrackTypes', label: 'Manage track types' },
    ],
  },
  {
    label: 'Agent & AI',
    keys: [
      { key: 'canManageAgents', label: 'Manage agents', hint: 'Mint/revoke keys, view activity + tools' },
      { key: 'canManageBrain', label: 'Manage agent brain', hint: 'Author identity/rules/commands/skills' },
      { key: 'canApprove', label: 'Toggle kill-switch', hint: 'Halt/resume all agent mutations' },
    ],
  },
  {
    label: 'Administration',
    keys: [
      { key: 'canManageTeam', label: 'Manage team', hint: 'Members, roles, passwords, permissions' },
    ],
  },
];
